import { useEffect, useRef } from "react";
import "./FloatingCursor.css";

function FloatingCursor() {
  const cursorRef = useRef(null);
  const animationFrame = useRef(null);
  const startTime = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    if (!cursor) return;

    const moveOnce = () => {
      const shouldMove = Math.random() > 0.3;
      const totalDuration = 4000 + Math.random() * 5000;
      const moveDuration = totalDuration - Math.random() * 2000;

      const dx = (Math.random() - 0.5) * window.innerWidth * 0.25;
      const dy = (Math.random() - 0.5) * window.innerHeight * 0.25;

      const scrollY = window.scrollY || window.pageYOffset;
      const scrollX = window.scrollX || window.pageXOffset;

      const startX = scrollX + Math.random() * (window.innerWidth - 60);
      const startY = scrollY + Math.random() * (window.innerHeight - 60);
      const endX = shouldMove ? startX + dx : startX;
      const endY = shouldMove ? startY + dy : startY;

      const controlX = (startX + endX) / 2 + (Math.random() - 0.5) * 100;
      const controlY = (startY + endY) / 2 + (Math.random() - 0.5) * 100;

      startTime.current = null;

      const animate = (timestamp) => {
        if (!startTime.current) startTime.current = timestamp;
        const elapsed = timestamp - startTime.current;

        if (elapsed >= totalDuration) {
          cursor.style.opacity = 0;
          setTimeout(moveOnce, 2000 + Math.random() * 2000);
          return;
        }

        const t = Math.min(elapsed / moveDuration, 1);
        const ease = t * t * (3 - 2 * t);

        const x = (1 - ease) * (1 - ease) * startX +
                  2 * (1 - ease) * ease * controlX +
                  ease * ease * endX;

        const y = (1 - ease) * (1 - ease) * startY +
                  2 * (1 - ease) * ease * controlY +
                  ease * ease * endY;

        const currentScrollY = window.scrollY || window.pageYOffset;
        const currentScrollX = window.scrollX || window.pageXOffset;

        cursor.style.transform = `translate(${x - currentScrollX}px, ${y - currentScrollY}px)`;
        cursor.style.opacity = 1;

        animationFrame.current = requestAnimationFrame(animate);
      };

      animationFrame.current = requestAnimationFrame(animate);
    };

    const initialTimeout = setTimeout(() => {
      moveOnce();
    }, 8000);

    return () => {
      clearTimeout(initialTimeout);
      cancelAnimationFrame(animationFrame.current);
    };
  }, []);

  return <div className="floating-cursor" ref={cursorRef}></div>;
}

export default FloatingCursor;
